import React from 'react';

// Catches render-time exceptions so a single bad component (e.g. unexpected API
// data shape) shows a recoverable message instead of unmounting the whole app to
// a blank screen.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface to the console for debugging; PostHog will also capture the throw.
    console.error('Render error caught by ErrorBoundary:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          maxWidth: 560, margin: '80px auto', padding: 24, textAlign: 'center',
          color: '#e5e7eb', fontFamily: 'system-ui, sans-serif',
        }}>
          <h2 style={{ marginBottom: 12 }}>Something went wrong on this page</h2>
          <p style={{ opacity: 0.8, marginBottom: 20 }}>
            This view hit an unexpected error. Your work is saved — you can go back and try again.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <button
              onClick={this.handleReset}
              style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #6b7280', background: 'transparent', color: '#e5e7eb', cursor: 'pointer' }}
            >
              Try again
            </button>
            <button
              onClick={() => { window.location.href = '/'; }}
              style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer' }}
            >
              Back to dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
